<div *ngIf="!isShowMainBlock"> 
    <app-status-report-search
    (generateReport)="generateReport($event)" [searchPageTitle]="searchPageTitle" [showDateRange]="false">
    </app-status-report-search>
</div>

<div *ngIf="isShowMainBlock &&  !isLoading">
    <div *ngIf="!isDetailsBlock">
        
        <div class="section-title" >TLR's Beyond Due Date Results</div>
    
      
      <div  class="content-block" >
        <div class="criterion-main-block">

            <div class="criterion-block">
                <p class='heading'>Criterion</p>
                <ul class="criterion-list">
                    <li>Facility: {{reportService.getCurrentFacilityId()}}</li>
                    <li>Repair Type: {{filters?.['repairType']}}</li>
                    <li>Division: {{filters?.['division']}}</li>
                    <li>Section: {{filters?.['section']}}</li>
                    <li>Plant: {{filters?.['plant']}}</li>
                    <li>Associated Plant - S/D: {{filters?.['associatedUnit']}}</li>
                    <li>LDAR: {{filters?.['ldar']}}</li>
                    <li>Component: {{filters?.['manageLeaksItems']}}</li>
                    <li>Material State: {{filters?.['materialStateItems']}}</li>
                    <li>Services: {{filters.selctedServices?.length ? filters.selctedServices?.join('|') : 'All'}}</li>
                </ul>

            </div>
            <div *ngIf="tlrBeyondDueDateReport.length">
                <p-table [value]="tlrBeyondDueDateReport" [paginator]="true"  [rows]="10" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>TLR Status</th>
                            <th>Count</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>
                                @if(item.TitleNumber> 0){

                                    <a class="Clickable" (click)="getDetails(item.TitleName)">{{item.TitleName}}</a>
                                }
                                @else{
                                    <span>{{item.TitleName}}</span>
                                }
                            </td>
                            <td>{{item.TitleNumber}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <tr class="total-sections-row">

                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        <div class="chart-block" *ngIf="tlrBeyondDueDateReport.length">
            <p-chart type="bar" [data]="chartData" [options]="chartOptions" [plugins]="plugins" class="chart" (onDataSelect)="selectData($event)"></p-chart>
        </div>
    </div>
    </div>

    <div class="content-details-block" *ngIf="isDetailsBlock">
        <div class="report-header">
            <div>
                <div class="section-title">TLR's Beyond Due Date Results</div>
                <div class="section-sub-title">TLR Status {{titleName}}</div>
                <div class="section-sub-title">
                    Repair Type: <span class="text-bold">{{filters.repairTypeDisplay}}</span> 
                    Division: <span class="text-bold">{{filters.divisionDisplay}}</span> 
                    Section: <span class="text-bold">{{filters.sectionDisplay}}</span> 
                    Plant: <span class="text-bold">{{filters.plantDisplay}}</span> 
                    Associated Plant - S/D: <span class="text-bold">{{filters.associatedUnitDisplay}}</span> 
                    LDAR: <span class="text-bold">{{filters.ldarDisplay}}</span> 
                    Component: <span class="text-bold">{{filters.manageLeaksItemsDisplay}}</span> 
                    Material State: <span class="text-bold">{{filters.materialStateItemsDisplay}}</span> 
                    Services: <span class="text-bold">{{filters.selctedServices ? filters.selctedServices.join('|') : 'All'}}</span>
                </div>
             </div>
            <div class="search-criteria">
                <p-button styleClass="p-button-secondary" (click)="downloadExcel()"> Export to Excel</p-button>
            </div>
        </div>
        <div  class="section-wrapper">
        <p-table [value]="beyondDueDateReportDataDetails" [paginator]="false" responsiveLayout="scroll" width="50%">
            <ng-template pTemplate="header">
                <tr>
                    <th>Tag Number</th>
                    <th>Entry Date</th>
                    <th>Op. User ID</th>
                    <th>Division</th>
                    <th>Section</th>
                    <th>Plant</th>
                    <th>LDAR</th>
                    <th>Op. PSI</th>
                    <th>Op. Temp</th>
                    <th>Service</th>
                    <th>Insp. User ID</th>
                    <th>Service Class</th>
                    <th>OA User ID</th>
                    <th>Permanent Repair Date</th>
                    <th>Eng. User ID</th>
                    <th>TLR Type</th>
                    <th>Maximo WO Number</th>
                    
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>
                        <a class="Clickable" routerLink="/details-section/{{item.Tag_Number}}">{{item.Tag_Number}}</a>
                    </td>
                    <td>{{item.Data_Entry_Date | date : 'MM/dd/YYYY'}}</td>
                    <td>{{item.Operator_CAI}}</td>
                    <td>{{item.Division}}</td>
                   <td>{{item.Section}}</td>
                    <td>{{item.Plant}}</td>
                    <td>{{item.LDAR}}</td>
                    <td>{{item.Oper_PSI}}</td>
                    <td>{{item.Oper_Temp}}</td>
                    <td>{{item.Service}}</td>
                    <td>{{item.InspectionCAI}}</td>
                    <td>{{item.ServiceClass}}</td>
                    <td>{{item.OACAI}}</td>
                    <td [ngClass]="getDateClass(item.Permanent_Repair_Date)">{{item.Permanent_Repair_Date | date : 'MM/dd/YYYY'}}</td>
                    <td>{{item.EngineeringCAI}}</td>
                    <td>{{item.TLRType}}</td>
                    <td>{{item.Maximo_WO_Number}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr class="total-sections-row">

                </tr>
            </ng-template>
        </p-table>
        </div>
    </div>

</div>